export default __webpack_public_path__ + "static/media/174667.e065a95a.jpg";